export const ROUTE_NAMES = {
	CELL_DETAIL: "cell-detail",
	COMPLIANCE_ADDRESS: "compliance-address",
	REVIEW_SITE: "review-site",
	REVEAL: "reveal",
	SITE_DETAIL: "site-detail",
} as const;

export type RouteName = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES];
